import {useMediaQuery} from 'react-responsive';
import {MEDIA} from '@/const';
import {aboveWidth, belowWidth} from '@/helper';

const useMediaRules = () => {
    const isAboveDesktop = useMediaQuery({query: aboveWidth(MEDIA.desktop)});
    const isAboveLaptopSm = useMediaQuery({query: aboveWidth(MEDIA.laptopSm)});
    const isBelowDesktopSm = useMediaQuery({query: belowWidth(MEDIA.desktopSm)});
    const isBelowLaptopLg = useMediaQuery({query: belowWidth(MEDIA.laptopLg)});
    const isBelowLaptopSm = useMediaQuery({query: belowWidth(MEDIA.laptopSm)});

    return {isBelowDesktopSm, isBelowLaptopLg, isBelowLaptopSm, isAboveLaptopSm, isAboveDesktop};
};

export default useMediaRules;
